import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "漫画排行榜", to: "/ranking" },
  { label: "完结推荐", to: "/ranking?filter=completed" },
  { label: "关于我们", to: "/about" },
];

const genreLinks = ["恋爱", "奇幻", "校园", "都市", "复仇", "悬疑"];

export default function Footer() {
  return (
    <footer className="mt-auto border-t border-background-200/70 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
        <div className="grid gap-8 md:grid-cols-4">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-book-open-line text-lg"></i>
              </span>
              <span className="font-display text-xl text-foreground-950">
                韩漫<span className="text-primary-500">悦读</span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-6 text-foreground-600">
              免费韩国漫画聚合阅读站，汇集热门排行榜、完结推荐与恋爱奇幻等题材分类。一站聚合热门冷门韩漫，持续更新，帮你快速找到想看的好漫画。
            </p>
            <div className="mt-5 flex gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 text-secondary-900 transition-colors hover:bg-primary-500 hover:text-background-50" aria-label="微信公众号">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 text-secondary-900 transition-colors hover:bg-primary-500 hover:text-background-50" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 text-secondary-900 transition-colors hover:bg-primary-500 hover:text-background-50" aria-label="哔哩哔哩">
                <i className="ri-bilibili-line"></i>
              </span>
            </div>
          </div>

          {/* Quick links */}
          <nav aria-label="页脚导航" className="flex flex-col gap-3">
            <h4 className="text-sm font-bold text-foreground-950">站内导航</h4>
            {quickLinks.map((l) => (
              <Link key={l.label} to={l.to} className="text-sm text-foreground-600 transition-colors hover:text-primary-500">
                {l.label}
              </Link>
            ))}
          </nav>

          {/* Genres */}
          <div className="flex flex-col gap-3">
            <h4 className="text-sm font-bold text-foreground-950">热门题材</h4>
            <div className="flex flex-wrap gap-2">
              {genreLinks.map((g) => (
                <Link
                  key={g}
                  to={`/ranking?genre=${encodeURIComponent(g)}`}
                  className="whitespace-nowrap rounded-full bg-background-200/70 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  {g}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 韩漫悦读 免费韩国漫画聚合阅读站 · 本站仅供内容展示与阅读参考
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="mailto:contact@hanmanhub.example.com" className="transition-colors hover:text-primary-500" rel="nofollow">
              contact@hanmanhub.example.com
            </a>
            <span className="flex items-center gap-1">
              <i className="ri-arrow-up-line"></i>
              <Link to="/" className="transition-colors hover:text-primary-500">返回顶部</Link>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}